const LS_ENABLE_KIOSK = 'configure.enableKiosk';
const LS_ENABLE_ACTIVITY_REDIRECT = 'configure.enableActivityRedirect';

function getBool(key) {
	if (typeof window === 'undefined') return false;

	const value = window.localStorage.getItem(key);
	return value === 'true';
}

function setBool(key, value) {
	if (typeof window === 'undefined') return;
	window.localStorage.setItem(key, String(value));
}

/**
 * Kiosk
 */
export function isKioskEnabled() {
	return getBool(LS_ENABLE_KIOSK);
}

export function setKioskEnabled(enabled) {
	setBool(LS_ENABLE_KIOSK, enabled);

	// If kiosk is disabled, also disable activity redirect
	if (!enabled) {
		setBool(LS_ENABLE_ACTIVITY_REDIRECT, false);
	}
}

/**
 * Activity Redirect
 */
export function isActivityRedirectEnabled() {
	// Activity redirect only valid if kiosk is enabled
	if (!isKioskEnabled()) return false;

	return getBool(LS_ENABLE_ACTIVITY_REDIRECT);
}

export function setActivityRedirectEnabled(enabled) {
	// Only allow enabling if kiosk is enabled
	if (!isKioskEnabled() && enabled) return;

	setBool(LS_ENABLE_ACTIVITY_REDIRECT, enabled);
}
